import React from 'react';
import { RoutePermittedRole } from 'shared/constants/AppConst';
const List = React.lazy(() => import('./PendingAdhocTrip'));
const Form = React.lazy(() => import('./AdhocTripForm'));
const EmployeeAdhocList = React.lazy(() => import('./AdhocList'));
const EmployeeAdhoc = React.lazy(() => import('./Corporate Adhoc Trip/AdhocList'));

export const AdhocTripConfig = [
  {
    permittedRole: RoutePermittedRole.manager,
    path: '/pending-adhoc-trip',
    element: <List />,
  },
  {
    permittedRole: [RoutePermittedRole.employee, RoutePermittedRole.manager],
    path: '/adhoc-trip-list',
    element: <EmployeeAdhocList />,
  },
  {
    permittedRole: [RoutePermittedRole.employee, RoutePermittedRole.manager],
    path: '/create-form-adhoc-trip',
    element: <Form />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/create-form/corporate-adhoc-trip',
    element: <EmployeeAdhoc />,
  },
];
